import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from 'src/app/app.component';
import { CrudHttp } from 'src/app/helpers/CrudHttp';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { BloqueConfiguracion, Pregunta, TipoRespuesta } from 'src/app/types/type';
declare var $: any;

@Component({
  selector: 'app-checklist-paso4',
  templateUrl: './checklist-paso4.component.html',
  styleUrls: ['./checklist-paso4.component.css']
})
export class ChecklistPaso4Component implements OnInit {
  idChecklist: number;
  idTipoRevision: number;
  title: string;
  item: object;
  rubros: any;
  bloques: BloqueConfiguracion[];
  bloqueEdit: any;
  subMenus: { active: boolean; child: boolean; label: string; router: string; class: string; }[];
  crudRubro: CrudHttp;
  preguntaEdit: any;
  tipoRespuestas: TipoRespuesta;
  crudRespuesta: CrudHttp;
  disableSave = false;
  tiposRespuestasCero = ['11', '8']

  constructor(private configService: ConfiguracionService, private activatedRoute: ActivatedRoute, private http: HttpClient, private router: Router, private father: AppComponent) {
    father.moduleName = 'Configuracion';

    this.idChecklist = parseInt(this.activatedRoute.snapshot.params.id);
    this.idTipoRevision = parseInt(this.activatedRoute.snapshot.params.idrevision);

    this.title = 'Checklist paso 4'

    this.crudRubro = new CrudHttp(http);
    this.crudRubro.methodGet = 'GetRubrosChecklist?idChecklist=' + this.idChecklist;

    this.crudRespuesta = new CrudHttp(http);
    this.crudRespuesta.methodGet = 'Getreguntas';
    this.crudRespuesta.methodPost = 'SetRelPreguntaTipoRespuestas';
    this.crudRespuesta.methodPut = 'UpdatePregunta';
    this.crudRespuesta.methodDelete = 'DeletePregunta';

    this.bloqueEdit = {
      Nombre: '',
      Ponderacion: 100,
      Orden: 1
    };

    this.preguntaEdit = {
      Descripcion: '',
      Ponderacion: 100,
      Orden: 1
    };
  }

  ngOnInit() {
    this.loadSubMenu();
    this.configService.loadInit(this.idChecklist)
      .subscribe(([respChecklist, respTipoRespuestas]) => {
        if (respChecklist.Result.Exito)
          this.bloques = respChecklist.Result.Data as BloqueConfiguracion[]
        else
          Utilerias.alertClient('', respChecklist.Result.Error, 1);

        if (respTipoRespuestas.Result.Exito)
          this.tipoRespuestas = respTipoRespuestas.Result.Data as TipoRespuesta
        else
          Utilerias.alertClient('', respTipoRespuestas.Result.Error, 1);
      });
  }

  newPreguntaClick(id) {
    localStorage['IdRubroNewPregunta'] = id;
    $('#modalNewPregunta').modal('show');
  }

  editPreguntaClick(item) {
    this.preguntaEdit = item;
    localStorage['IdPreguntaEdit'] = item.IdPregunta;
    $('#modalEditPregunta').modal('show');
  }

  frmPostTipoRespuestas(e: Event) {
    e.preventDefault();
    this.disableSave = true;
    const idBloque = e.target['dataset']['idbloque'];
    const idRubro = e.target['dataset']['idrubro'];

    const preguntas =
      this.bloques.find(b => b.IdBloque == idBloque)
        .Rubros.find(r => r.IdRubro == idRubro)
        .Preguntas.map(p => {
          return {
            IdRubro: parseInt(idRubro),
            IdPregunta: p.IdPregunta,
            IdTipoRespuesta: parseInt($(`#select-${p.IdPregunta}`).val())
          };
        });

    this.configService.setRelPreguntaTipoRespuestas(preguntas)
      .subscribe(resp => {
        if (!resp.Result.Exito) Utilerias.alertClient('', resp.Result.Error, 0)
        this.disableSave = false;
      });
  }

  existsTiposRespuestas() {
    for (let bloque of this.bloques) {
      for (let rubro of bloque.Rubros) {
        for (let pregunta of rubro.Preguntas) {
          if (pregunta.TipoRespuesta.IdTipoRespuesta == 0) {
            return false;
          }
        }
      }
    }
    return true;
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: 'Paso 1',
        router: `../../../ChecklistPaso1/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: false,
        child: true,
        label: 'Paso 2',
        router: `../../../ChecklistPaso2/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: false,
        child: true,
        label: 'Paso 3',
        router: `../../../ChecklistPaso3/${this.idChecklist}/${this.idTipoRevision}`,
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: true,
        child: false,
        label: 'Paso 4',
        router: null,
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }

  redirectPaso5() {
    this.router.navigate([`Configuracion/ChecklistPaso5/${this.idChecklist}/${this.idTipoRevision}`]);
  }

  validarPonderacion(event, idPregunta: number, ponderacion: number, preguntas: Pregunta[]) {
    const inpunt = event.target as HTMLInputElement;
    let totalPonderaciones = this.sumaPonderaciones(preguntas);

    if (this.tiposRespuestasCero.includes(inpunt.value) && ponderacion != 0) {
      Utilerias.alertConfirm('La ponderación de su pregunta cambiara a 0.<br>¿Desea continuar?')
        .then(resp => {
          if (resp.value) {
            let flag = false;
            for (let bloque of this.bloques) {
              for (let rubro of bloque.Rubros) {
                for (let pregunta of rubro.Preguntas) {
                  if (flag = pregunta.IdPregunta == idPregunta) {
                    totalPonderaciones = totalPonderaciones - pregunta.Ponderacion
                    if (totalPonderaciones < 100) {
                      $(`#select-${idPregunta}`).val(0);
                      Utilerias.alertClient(
                        '',
                        'La suma de las ponderaciones no puede ser menor a 100<br>Está opción cambia el valor de tu ponderación a 0', 1);
                      flag = true;
                      break;
                    }
                    pregunta.Ponderacion = 0;
                    break;
                  }
                }
                if (flag) break;
              }
              if (flag) break;
            }
          } else {
            $(`#select-${idPregunta}`).val(0);
          }
        })
    }
  }

  sumaPonderaciones(preguntas: Pregunta[]) {
    return preguntas.reduce((previous, current) => {
      return previous + current.Ponderacion
    }, 0)
  }
}
